module.exports = __webpack_public_path__ + "img/yuanlian_logo.96646bd9.png";